import { createGlobalStyle } from 'styled-components';

import reset from './reset.css';

const GlobalStyle = createGlobalStyle`
	
	@import url('https://fonts.googleapis.com/css?family=Source+Serif+Pro:400,700&display=swap');	
	@import url('https://use.typekit.net/eaz6mcp.css');
	

	${reset}


	* {
		box-sizing: border-box;
	}
	
	.hide {
		position: absolute !important;
		clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
		clip: rect(1px, 1px, 1px, 1px);
		padding: 0 !important;
		border: 0 !important;
		height: 1px !important;
		width: 1px !important;
		overflow: hidden;
	}
	
	.md-content {
		white-space: pre-wrap;
	}

	ol {
		list-style: none;
  		counter-reset: counter;
  		li {
		 	position: relative;
			list-style-type: none;
			margin-left: 1rem;
			counter-increment: counter;
			&::before {
				content: counter(counter) ")";
				position: absolute;
				left: -1rem;
			}
		}
	}

	strong, .bold {
		font-weight: 700;
	}
	em {
		font-style: italic;
	}

	html {
		font-size: 16px;
	}

	body {
		font-size: 16px;
		position: relative;
		z-index: 1;
		background-color: #fff;
		color: ${(p) => p.theme.color.dark};
		font-family: ${(props) => props.theme.fonts.body};
		overflow-x: hidden; 
		h1 {
			font-family: ${(p) => p.theme.fonts.heading};
			font-size: 3rem;
			line-height: 4rem;
		}
		h2 {
			font-family: ${(p) => p.theme.fonts.heading};
			font-size: 2.5rem;
			line-height: 3rem;
		}

		h3 {
			font-size: 1.5rem;
			line-height: 2rem;
		}
		p {
			font-size: 1rem;
			line-height: 1.5rem;
		}
		

		p,
		h3,	
		h4,
		li,
		th,
		td,
		a,
		button {
			font-family: ${(p) => p.theme.fonts.body};
		} 
		img {
			display: block;
			max-width: 100%;
		}
	
		input, textarea {
			border: none;
			border-radius: unset;
			font-size: 1rem;
			font-family: ${(props) => props.theme.fonts.body};
		}
		button {
			cursor: pointer;
			appearance: none;
			padding: 0;
			margin: 0;
    		text-decoration: none;
			border: none;
			color: #fff;
			background-color: transparent;
		}
		a {
			color: #fff;
			text-decoration: none;
		}
		hr {
			border: none;
			display: block;
			height: 1px;
			margin: 0.5rem 0;
		}
	}
	
`;

export default GlobalStyle;
